import React from 'react';
import arrowdown from '../Img/arrowdown.svg';

const CollapseAdButton = ({cardTitle, setIsOpen, isOpen,jobCode,jobLocation}) => {

    return (
        <button className="careers-collapse" onClick={() => setIsOpen(jobCode,jobLocation,isOpen)}>
          <span className="">{cardTitle}</span>
          <div className={`${isOpen ? 'careers-collapse__iconDown' : 'careers-collapse__iconUp'}`}  style={{ backgroundImage: arrowdown.bg() }}></div>
        </button>
    );
}

export default CollapseAdButton;
